var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chat-container"},[_c('ChatList',{attrs:{"propChats":_vm.chatList,"loading":_vm.loadingData},on:{"open-messages":_vm.mountMessages}}),_c('ChatBox',{attrs:{"messages":_vm.messages,"vizinhos":_vm.vizinhos,"bairro":_vm.bairro,"zelador":_vm.zelador,"az":_vm.az}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }